// IMR.Suite.Common.Activity
export enum Activity {
	LOGIN = 1,
	DEVICE_LIST = 2,
	DEVICE_DEL = 3,
	DEVICE_EDIT = 4,
	DEVICE_ADD = 5,

	OPERATOR_LIST = 6,
	OPERATOR_DEL = 7,
	OPERATOR_ADD = 8,
	OPERATOR_EDIT = 9,
	OPERATOR_PERMISSIONS_EDIT = 10,
	OPERATOR_CAN_CHOOSE_CONFIGURATION = 11,
	OPERATOR_CAN_CHANGE_CONFIGURATION = 12,
	OPERATOR_EXPORT_OP = 13,
	OPERATOR_IMPORT_OP = 14,
	OPERATOR_PERMISSIONS_ROLE_CHOOSE = 15,
	OPERATOR_PERMISSIONS_CUSTOM_PERM_CHOOSE = 16,
	OPERATOR_PERMISSIONS_EFFECTIVE_PERMISSIONS = 17,
	OPERATOR_LIST_ALL = 18,
	OPERATOR_MANAGE_SOT = 19,
	OPERATOR_IMRSC_SOT = 20,

	//2350-2399
	OPERATOR_IMR_SERVER_EDIT = 2350,
	OPERATOR_SHIPPING_LIST_NOTIFICATIONS_EDIT = 2351,
	OPERATOR_CAN_ENABLE_SRT = 2352,
	OPERATOR_RADIO_DEVICE_TESTER_NEW_EDIT = 2353,
	OPERATOR_IMRSC_ISU = 2354,
	OPERATOR_NOTIFICATIONS_LIST = 2355,
	OPERATOR_PERFORMANCE_YELLOW_THRESHOLD_LIST = 2356,
	OPERATOR_PACKAGE_NOTIFICATIONS_EDIT = 2357,
	OPERATOR_GSM_API = 2358,
	OPERATOR_WCF_BILLING = 2359,
	OPERATOR_FITTER_NEWS_EDIT = 2360,
	OPERATOR_FITTER_DEPOSITORY_EDIT = 2361,
	OPERATOR_DEFAULT_PARAMETERS_EDIT = 2362,
	OPERATOR_CAN_ADD_CUSTOM_ORGANIZATIONAL_UNIT = 2363,
	OPERATOR_ADVANCED_DEFAULT_CONFIGURATION_OP = 2364,
	OPERATOR_SMS_NOTIFICATIONS_LIST = 2365,
	OPERATOR_ALL_ACTIVITIES_AVAILABLE_TO_ASSIGN = 2366,
	ALLOWED_OPERATOR_TO_EDIT_ACTIVITIES = 2367,
	OPERATOR_SEND_NOTIFICATION_OP = 2368,
	OPERATOR_ORANGE_PAYMENT = 2369,
	OPERATOR_DETAILS_HIDDEN_UI_OBJECT_PROPERTIES = 2370,
	OPERATOR_ALLOW_SEND_PREPAID_ACTION = 2371,
	OPERATOR_FORCE_QUEUE = 2372,
	OPERATOR_DEFINE_CONSUMPTION_PROFILE = 2373,
	OPERATOR_FP_PORTAL_ROLE_ADMIN = 2374,
	OPERATOR_CAN_TOP_UP_ACCOUNT = 2375,
	OPERATOR_LDAP_SYNCHRONIZATION_ACTION_TYPE = 2376,
	OPERATOR_LOCATION_LIST_VISIBLE_EC_BALANCE = 2377,
	OPERATOR_LOCATION_LIST_VISIBLE_PREPAID_BALANCE = 2378,
	OPERATOR_LOCATION_LIST_VISIBLE_BATTERY_STATE = 2379,
	OPERATOR_LOCATION_LIST_VISIBLE_METER_COUNTER = 2380,
	OPERATOR_DETAILS_READONLY_UI_OBJECT_PROPERTIES = 2381,
	OPERATOR_LOCATION_LIST_VISIBLE_TARIFF_FROM_DEVICE = 2382,
	OPERATOR_FITTER_DEPOSITORY_VIEW = 2383,
	OPERATOR_ALLOW_SEND_COMMISSION = 2384,
	OPERATOR_ALLOW_SEND_DECOMMISSION = 2385,
	OPERATOR_MODULE_HIDDEN_UI_OBJECT_PROPERTIES = 2387,

	OPERATOR_COPY = 2389,

	METER_LIST = 21,
	METER_ADD = 22,
	METER_EDIT = 23,
	METER_DEL = 24,
	METER_ADVANCED_READING_CONFIG_OP = 25,
	METER_DETAILS_HIDDEN_UI_OBJECT_PROPERTIES = 26,
	METER_CLUSTER_ASSIGNMENT_OP = 27,

	LOCATION_LIST = 31,
	LOCATION_ADD = 32,
	LOCATION_DEL = 33,
	LOCATION_EDIT = 34,
	LOCATION_INSTALLATION_FORM_OP = 35,
	LOCATION_RELATED_EDIT = 36,
	LOCATION_ADD_FROM_FILE_SGM = 37,
	LOCATION_PAREMETER_LIST = 38,
	LOCATION_WITH_DEVICE_ALLOW_REMOVE = 39,

	SETTINGS_LIST = 40,
	ALLOWED_DISTRIBUTOR = 41, // do tegu numeru sa stare uprawnienia, nie bedziemy juz ich psuć
	ALLOWED_ACTION_TYPE = 42,
	ALLOWED_ROLE = 43,
	ALLOWED_REPORT = 44,
	ALLOWED_TASK_TYPE = 45,
	ALLOWED_IMR_SERVER = 46,
	ALLOWED_ACTIVITES = 47,
	ALLOWED_LOCATION_STATE_TYPE = 48,
	ALLOWED_LOCATION = 49,
	SGM_OPERATOR_PERMISSIONS_FOR_MULTIPLE_ROLE_CHOOSE = 50,
	SELECT_RDG_FROM_THE_LIST = 51,
	ALLOWED_ISSUE_STATUS_EDIT = 52,
	ALLOWED_ISSUE_TYPE = 53,

	AREA_ADD = 54,
	AREA_EDIT = 55,
	AREA_DEL = 56,
	AREA_LIST = 57,
	WAREHOUSE_EDIT = 58,
	AREA_CLUSTER_EDIT = 59,
	AREA_LOCATIONS_EDIT = 60,
	AREA_SUPPLIER_HISTORY_VIEW = 61,
	AREA_TARIFF_HISTORY_VIEW = 62,
	AREA_INSTALLED_AUX_DEVICES_VIEW = 63,
	ALLOWED_LOCATION_GROUP_LIST = 64,
	ALLOWED_LOCATION_GROUP_EDIT = 65,
	ALLOWED_DATA_TYPE = 66,
	ALLOWED_EXISTING_ITEM_PARAM_EDIT = 67,
	ALLOWED_HOST_NAME = 68,
	SETTINGS_LAST_MEASURE_COLOR = 69,
	ALLOWED_LOCATION_TYPE = 70,
	TOOLS_LIST = 71,
	ALLOWED_METER_TYPE = 72,

	//aż do 99
	//100 - 149

	ROLE_LIST = 100,
	ROLE_ADD = 101,
	ROLE_EDIT = 102,
	ROLE_DEL = 103,
	ROLE_PERMISSIONS_EDIT = 104,

	//150 - 199
	DATA_TYPE_LIST = 150,
	DATA_TYPE_ADD = 151,
	DATA_TYPE_EDIT = 152,
	DATA_TYPE_DEL = 153,
	DATA_TYPE_EXPORT_OP = 154,
	DATA_TYPE_IMPORT_OP = 155,
	DATA_FORMAT_GROUP_LIST = 156,
	DATA_FORMAT_GROUP_ADD = 157,
	DATA_FORMAT_GROUP_EDIT = 158,
	DATA_FORMAT_GROUP_DEL = 159,

	//200 - 249
	DATA_TYPE_GROUP_LIST = 200,
	DATA_TYPE_GROUP_ADD = 201,
	DATA_TYPE_GROUP_EDIT = 202,
	DATA_TYPE_GROUP_DEL = 203,
	DATA_TYPE_GROUP_MODULE_HIDDEN_UI_OBJECT_PROPERTIES = 204,
	DATA_TYPE_GROUP_DETAILS_HIDDEN_UI_OBJECT_PROPERTIES = 205,
	DATA_TYPE_GROUP_DETAILS_READONLY_UI_OBJECT_PROPERTIES = 206,

	//250 - 299
	RESOURCE_LIST = 250,
	RESOURCE_ADD = 251,
	RESOURCE_EDIT = 252,
	RESOURCE_DEL = 253,
	RESOURCE_EXPORT_OP = 254,
	RESOURCE_IMPORT_OP = 255,

	//300 - 349
	SIM_CARD_LIST = 300,
	SIM_CARD_ADD = 301,
	SIM_CARD_EDIT = 302,
	SIM_CARD_DEL = 303,

	SIM_CARD_IMPORT_OP = 304,
	SIM_CARD_EXPORT_OP = 305,
	SIM_CARD_DETAILS_HIDDEN_UI_OBJECT_PROPERTIES = 306,
	SIM_CARD_DETAILS_READONLY_UI_OBJECT_PROPERTIES = 307,
	SIM_CARD_MODULE_HIDDEN_UI_OBJECT_PROPERTIES = 308,

	//350 - 399
	MEASUREMENTS_LIST = 350,
	MEASUREMENTS_VALIDATE_OP = 351,
	MEASUREMENTS_INVALIDATE_OP = 352,
	MEASUREMENTS_MANUAL_ADD_OP = 353,
	MEASUREMENTS_ONLINE_OP = 354,
	MEASUREMENTS_IMPORT_REFUEL_OP = 355, //import pliku tankowania (np. shell w SC)
	MEASUREMENTS_LIST_PREPAY = 356,
	MEASUREMENTS_REPORTS = 357,
	MEASUREMENT_EDIT_HIDDEN_UI_OBJECT_PROPERTIES = 358,

	//400 - 449
	REPORTS_LIST = 400,
	REPORT_CONFIGURE_OP = 401,
	REPORT_PACKETS_LIST = 402,
	REPORT_DEFINITION_LIST = 403,
	REPORT_DEFINITION_ADD = 404,
	REPORT_DEFINITION_EDIT = 405,
	REPORT_DEFINITION_DEL = 406,
	REPORT_EDIT = 407,
	REPORT_DEL = 408,
	REPORT_DETAILS_HIDDEN_UI_PROPERTIES = 409,
	REPORT_ADD = 410,
	REPORT_GENERATE_OP = 411,
	REPORT_DETAILS_READONLY_UI_OBJECT_PROPERTIES = 412,
	REPORT_MODULE_HIDDEN_UI_OBJECT_PROPERTIES = 413,
	REPORT_GENERATED_LIST = 414,

	//450 - 499
	ACTION_LIST = 450,
	ACTION_RUN = 451,
	ACTION_STOP = 452,
	ACTION_CONFIGURE_OP = 453,
	ACTION_TYPES_CONFIGURE_OP = 454,
	ACTION_DEFS_CONFIGURE_OP = 455,
	ACTION_STOP_WITH_ERROR = 456,
	PROFILE_SENDER_LIST = 457,
	ACTION_DEFS_IMPORT_OP = 458,
	ACTION_DEFS_EXPORT_OP = 459,
	ACTION_DEF_DETAILS_HIDDEN_UI_OBJECT_PROPERTIES = 460,
	ACTION_DEF_DETAILS_READONLY_UI_OBJECT_PROPERTIES = 461,
	ACTION_DEFS_COPY = 462,
	ALLOWED_ACTION_DEF = 463,
	ACTION_DETAILS_HIDDEN_UI_PROPERTIES = 464,
	ACTION_DETAILS_READONLY_UI_OBJECT_PROPERTIES = 465,
	ACTION_MODULE_HIDDEN_UI_OBJECT_PROPERTIES = 466,
	ACTION_RUN_PLAN_OP = 467,
	ACTION_ADD_SENDING_EXPLANATION = 474,

	//500 - 549
	DEVICE_HIERARCHY_LIST = 500,
	DEVICE_HIERARCHY_EDIT = 501,
	DEVICE_IMPORT_OP = 502,
	DEVICE_EXPORT_OP = 503,
	PACKET_LIST = 504, //uprawnienie do ogladania pakietów (odebranych/wyslanych)
	DEVICE_ONSITE_OP = 505,
	DEVICE_ADD_FROM_SERVICE_POOL = 506,
	DEVICE_TYPES_REPORT_OP = 507,
	DEVICE_INSTALLATION_PLAN_REPORT_OP = 508,
	DEVICE_DEPOSITORY_REPORT_VIEW = 509,
	DEVICE_DEPOSITORY_REPORT_VIEW_ADMIN = 510,
	DEVICE_INSPECTION = 511,
	DEVICE_ADD_SET = 512,
	DEVICE_PAREMETERS_LIST = 513,
	DEVICE_ADVANCED_HISTORY_LIST = 514,
	DEVICE_DASHBOARD_VIEW = 515,
	DEVICE_DASHBOARD_ADVANCED_VIEW = 516,
	DEVICE_POSSIBLE_SIM_CARD_LIST = 517,
	DEVICE_SIM_CARD_REPLACE_OP = 518,
	DEVICE_CONFIGURATION_LIST = 519,
	DEVICE_FIRMWARE_LIST = 520,
	DEVICE_PROFILE_LIST = 521,
	DEVICE_SET_LIST = 522,
	DEVICE_SEND_TO_SERVER_OP = 523,
	DEVICE_IMPORT_FROM_FILE_SGM = 524,
	DEVICE_DASHBOARD_MAIN_CHART_VIEW = 525,
	DEVICE_DASHBOARD_ADDITIONAL_CHART_VIEW = 526,
	DEVICE_DIAGNOSTIC_DATA_VIEW = 527,
	DEVICE_BULK_EDIT_HIDDEN_UI_OBJECT_PROPERTIES = 528,
	DEVICE_DETAILS_READONLY_UI_OBJECT_PROPERTIES = 529,
	DEVICE_DETAILS_HIDDEN_UI_OBJECT_PROPERTIES = 530,
	PACKET_FREQ_REASON_LIST = 531,
	ACCESS_TO_CRYPTOGRAPHIC_KEYS = 532,
	DEVICE_CONNECTION_LIST = 533,
	DEVICE_REWAREHOUSING_OP = 534,
	DEVICE_CONFIGURATION_CONSISTENCY_CHECK_OP = 535,
	DEVICE_CONNECTION_DETAILS_READONLY_UI_OBJECT_PROPERTIES = 536,
	DEVICE_CONFIGURATION_SEND = 537,
	DEVICE_CONNECTION_EXPORT_OP = 538,
	DEVICE_CONNECTION_MODULE_HIDDEN_UI_OBJECT_PROPERTIES = 539,
	EXTERNAL_DEVICE_ADD = 546,

	//550 - 599
	ALARM_LIST = 550,
	ALARM_ADD = 551,
	ALARM_EDIT = 552,
	ALARM_DEL = 553,
	ALARM_CONFIGURE_OP = 554,
	CONFIGURATION_PROFILE_MAP = 555,
	CONFIGURATION_PROFILE = 556,
	TEMPLATE_CONFIRM = 557,
	ALARM_OPERATOR_EDIT = 558,
	ALARM_DETAILS_HIDDEN_UI_PROPERTIES = 559,
	ALARM_DETAILS_READONLY_UI_OBJECT_PROPERTIES = 560,

	//600- 649 actor (osoba, np. jako kontakt do lokalizacji lub osoba zglaszajaca problem (issue)).
	//Informacje podstawowe dla Operatora (nie istnieje operator bez aktora)
	ACTOR_LIST = 600,
	ACTOR_ADD = 601,
	ACTOR_EDIT = 602,
	ACTOR_DEL = 603,
	ACTOR_MEMBERSHIP_EDIT = 604,
	ACTOR_IMPORT_OP = 605,
	ACTOR_DETAILS_HIDDEN_UI_PROPERTIES = 606,
	ACTOR_DETAILS_READONLY_UI_OBJECT_PROPERTIES = 607,
	ACTOR_MODULE_HIDDEN_UI_OBJECT_PROPERTIES = 608,
	// ACTOR_EXPORT_OP = 609,

	//650 - 699
	ISSUE_LIST = 650,
	ISSUE_ADD = 651,
	ISSUE_EDIT = 652,
	ISSUE_DEL = 653,
	ISSUE_JCI_OP = 654,
	ISSUE_ADD_FROM_FILE_OP = 655,
	ISSUE_DISPLAY_IN_TEXT_OP = 656,
	ISSUE_EQUIPMENT_OP = 657, //zgłoszenie dla urządzeń/meterów
	ISSUE_ATTRIBUTES_EDIT = 658,
	ISSUE_ATTRIBUTES_LIST = 659,
	ISSUE_ATTRIBUTES_DEL = 660,
	ISSUE_GENERATE_REPORT_OP = 661,
	ISSUE_DETAILS_HIDDEN_UI_OBJECT_PROPERTIES = 662,
	ALLOWED_ISSUE_STATUS_VIEW = 663,
	ALLOWED_ISSUE_STATUS_CHANGE = 664,
	ISSUE_ATTACHMENT_DELETE = 665,
	ISSUE_MULTIPLE_ADD = 666,
	ISSUE_DETAILS_READONLY_UI_OBJECT_PROPERTIES = 667,
	ISSUE_MODULE_HIDDEN_UI_OBJECT_PROPERTIES = 668,
	ISSUE_EXPORT_OP = 669,
	ISSUE_IMPORT_OP = 670,

	//700 - 749
	TASK_LIST = 700,
	TASK_ADD = 701,
	TASK_EDIT = 702,
	TASK_DEL = 703,
	TASK_CLIENT_PAYMENT_LIST = 704,
	TASK_CLIENT_PAYMENT_EDIT = 705,
	TASK_FITTER_PAYMENT_LIST = 706,
	TASK_FITTER_PAYMENT_EDIT = 707,
	TASK_FITTER_FEEDBACK_EDIT = 708,
	TASK_INSTALLATION_PROTOCOL_VIEW = 709,
	TASK_WAREHOUSE_ORDER_VIEW = 710,
	TASK_WAREHOUSE_ORDER_EDIT = 711,
	TASK_ATTRIBUTES_EDIT = 712,
	TASK_ATTRIBUTES_LIST = 713,
	TASK_ATTRIBUTES_DEL = 714,
	ALLOWED_SUPPLIER = 715,
	TASK_ARRANGED_FITTER_FISIT_DATE_VIEW = 716,
	TASK_REFUEL_AUDIT_MOVIE_VIEW = 717,
	ALLOWED_TASK_ATTACHMENT_EXTENSION = 718,
	TASK_DETAILS_HIDDEN_UI_OBJECT_PROPERTIES = 719,
	ALLOWED_TASK_STATUS_VIEW = 720,
	ALLOWED_TASK_STATUS_EDIT = 721,
	ALLOWED_TASK_STATUS_CHANGE = 722,
	TASK_DETAILS_READONLY_UI_OBJECT_PROPERTIES = 723,
	TASK_ATTACHMENTS_EDIT = 724,
	TASK_MULTIPLE_ADD = 725,
	TASK_EXPORT = 726,
	TASKS_MODULE_HIDDEN_UI_OBJECT_PROPERTIES = 727,
	ALLOWED_TASK_GROUP = 728,
	TASK_ATTACHMENT_DELETE = 729,
	TASK_EXPORT_OP = 730,
	TASK_FITTER_LIST = 731,
	TASK_SHOW_FITTER_AREA_OP = 732,
	TASK_MODULE_HIDDEN_UI_OBJECT_PROPERTIES = 733,
	TASK_IMPORT_OP = 735,

	TASK_PROTOCOL_VERIFICATION_VIEW = 740,

	//750 - 799
	ROUTE_LIST = 750,
	ROUTE_ADD = 751,
	ROUTE_EDIT = 752,
	ROUTE_DEL = 753,
	ROUTE_TMQ_EXPORT_OP = 754, //uprawnienie do generowania pliku xls w formacie TMQ
	ROUTE_EXPORT_OP = 754, //uprawnienie do exportu trasy
	ROUTE_POINT_DEVICES_EDIT = 756,
	WALKED_BY_433_READOUTS_SGM_SUPPORT = 757,
	ROUTE_DETAILS_HIDDEN_UI_PROPERTIES = 758,
	ROUTE_IMPORT_OP = 759,
	ALLOWED_ROUTE_ATTACHMENT_EXTENSION = 760,
	ROUTE_DETAILS_READONLY_UI_OBJECT_PROPERTIES = 761,
	ROUTE_SHOW_FITTER_AREA_OP = 762,
	ROUTE_MODULE_HIDDEN_UI_OBJECT_PROPERTIES = 763,

	//ROUTE_DEF 790 - 799
	ROUTE_DEF_LIST = 790,
	ROUTE_DEF_ADD = 791,
	ROUTE_DEF_EDIT = 792,
	ROUTE_DEF_DEL = 793,

	//800 - 849
	LOCATION_IMPORT_OP = 800,
	LOCATION_EXPORT_OP = 801,
	LOCATION_MESH_OP = 802,
	LOCATION_COLLECTOR_OP = 803, //uprawnienie do aplikacji pobierajacej informacje o lokalizacjach z serwerow klienckich (SC)
	LOCATION_METER_ASSOCIATION_OP = 804, //powiazanie lokalizacji z meterem pomijajac urzadzenie
	LOCATION_DEVICE_ASSOCIATION_OP = 805, //powiazanie lokalizacji z urządzeniem - aktywowanie przycisku Change dla Device set w SGM
	LOCATION_STATE_CHANGE = 806, //zmiana stanu lokalizacji - aktywowanie przycisku Change dla Location state w SGM
	DISPLAY_CID_AS_MPRN = 807,
	GROUPING_LOCATION_TYPE_LIST = 808,
	GROUPING_LOCATION_TYPE_EDIT = 809,
	LOCATION_DETAILS_HIDDEN_UI_OBJECT_PROPERTIES = 810,
	LOCATION_WIZARD = 811,
	LOCATION_INSTALLATION_DETAILS_READONLY_UI_OBJECT_PROPERTIES = 812,
	LOCATION_DETAILS_READONLY_UI_OBJECT_PROPERTIES = 813,
	LOCATION_EQUIPMENT_EDIT = 814,
	LOCATION_MODULE_HIDDEN_UI_OBJECT_PROPERTIES = 816,
	LOCATION_PROBLEM_CONFIRMATION_OP = 818,
	LOCATION_PLAN_DELIVERY_TIME_OP = 819,
	LOCATION_GROUP_MULTIPLE_ASSIGN_OP = 820,
	LOCATION_CONFIGURATION_SEND = 821,
	LOCATION_COPY = 822,

	//850 - 899
	DEVICE_TYPE_LIST = 850,
	DEVICE_TYPE_ADD = 851,
	DEVICE_TYPE_EDIT = 852,
	DEVICE_TYPE_DEL = 853,
	DEVICE_TYPE_GROUP_LIST = 854,
	ALLOWED_DEVICE_TYPE_SETTINGS_EDIT = 855,
	ALLOWED_DEVICE_TYPE_ALARMS_VIEW = 856,
	DEVICE_MODULE_HIDDEN_UI_OBJECT_PROPERTIES = 857,

	//900 - 924
	SYSTEM_DRIVER_LIST = 900, //zawiera uprawnienie do DEVICE_DRIVER, TRASMISSION_DRIVER, PROTOCOL_DRIVER
	SYSTEM_DRIVER_ADD = 901,
	SYSTEM_DRIVER_EDIT = 902,
	SYSTEM_DRIVER_DEL = 903,
	SYSTEM_DRIVER_UPLOAD = 904,

	//925 - 949
	SYSTEM_ROUTING_LIST = 925, //zawiera uprawnienie do ROUTE_TABLE, CONNECTION
	SYSTEM_ROUTING_ADD = 926,
	SYSTEM_ROUTING_EDIT = 927,
	SYSTEM_ROUTING_DEL = 928,

	//950 - 999
	METER_IMPORT_OP = 950,
	METER_EXPORT_OP = 951,
	METER_TYPE_LIST = 952,
	METER_TYPE_GROUP_LIST = 953,
	METER_TYPE_CLASS_LIST = 954,
	METER_TYPE_DEVICETYPE_LIST = 955,
	METER_TYPE_EDIT = 956,
	METER_TYPE_GROUP_EDIT = 957,
	METER_TYPE_CLASS_EDIT = 958,
	METER_TYPE_DEVICETYPE_EDIT = 959,
	METER_PARAMETER_LIST = 960,
	METER_TYPE_GROUP_EXPORT_OP = 961,
	METER_TYPE_GROUP_IMPORT_OP = 962,
	METER_DECLARE_EXPECTED_CONSUMPTION = 963,
	METER_DETAILS_READONLY_UI_OBJECT_PROPERTIES = 964,
	METER_MODULE_HIDDEN_UI_OBJECT_PROPERTIES = 965,

	//1000 - 1049 tarrifs
	TARIFF_LIST = 1000,
	TARIFF_ADD = 1001,
	TARIFF_EDIT = 1002,
	TARIFF_DEL = 1003,
	LOCATION_TARIFF_VIEW = 1004,
	LOCATION_TARIFF_EDIT = 1005,
	LOCATION_TARIFF_HISTORY_VIEW = 1006,
	ALLOWED_TARIFF = 1007,
	TARIFF_EXPORT_OP = 1008,
	TARIFF_IMPORT_OP = 1009,
	TARIFF_DETAILS_READONLY_UI_OBJECT_PROPERTIES = 1010,
	TARIFF_MODULE_HIDDEN_UI_OBJECT_PROPERTIES = 1011,
	TARIFF_DETAILS_HIDDEN_UI_PROPERTIES = 1012,
	TARIFF_COPY = 1013,

	//1050 - 1099 consumers
	CONSUMER_LIST = 1050,
	CONSUMER_ADD = 1051,
	CONSUMER_EDIT = 1052,
	CONSUMER_DELETE = 1053,

	CONSUMER_TYPE_LIST = 1060,
	CONSUMER_TYPE_ADD = 1061,
	CONSUMER_TYPE_EDIT = 1062,
	CONSUMER_TYPE_DEL = 1063,

	CONSUMER_FINANCIAL_STATE_VIEW = 1064,
	CONSUMER_TRANSACTION_HISTORY_VIEW = 1065,
	CONSUMER_CONTACT_HISTORY_VIEW = 1066,
	CONSUMER_LOCATION_HISTORY_VIEW = 1067,
	CONSUMER_SMS_ALERTS_VIEW = 1068,
	CONSUMER_NOTIFICATIONS_VIEW = 1069,
	CONSUMER_OPERATORS_VIEW = 1070,
	CONSUMER_PAYMENT_MODULE_VIEW = 1071,
	CONSUMER_NOTIFICATION_HISTORY_VIEW = 1072,
	CONSUMER_CREDIT_LEVEL_VIEW = 1073,
	CONSUMER_DETAILS_READONLY_UI_OBJECT_PROPERTIES = 1074,
	CONSUMER_MODULE_HIDDEN_UI_OBJECT_PROPERTIES = 1075,
	CONSUMER_DETAILS_HIDDEN_UI_PROPERTIES = 1076,
	CONSUMER_SEND_TOP_UP = 1077,

	CONSUMER_TYPE_DETAILS_READONLY_UI_OBJECT_PROPERTIES = 1079,
	CONSUMER_TYPE_DETAILS_HIDDEN_UI_PROPERTIES = 1080,
	CONSUMER_TYPE_MODULE_HIDDEN_UI_OBJECT_PROPERTIES = 1081,

	//1100 - 1149 consumer transactions
	CONSUMER_TRANSACTION_LIST = 1100,
	CONSUMER_TRANSACTION_ADD = 1101,
	CONSUMER_TRANSACTION_ROLLBACK = 1102,
	BILLING_DOCUMENTS_PANEL = 1103,

	//1150 - 1199 suppliers
	SUPPLIER_LIST = 1150,
	SUPPLIER_ADD = 1151,
	SUPPLIER_EDIT = 1152,
	SUPPLIER_DELETE = 1153,
	SUPPLIER_LOCATIONS_EDIT = 1154,
	SUPPLIER_MODULE_HIDDEN_UI_OBJECT_PROPERTIES = 1155,
	SUPPLIER_DETAILS_HIDDEN_UI_OBJECT_PROPERTIES = 1156,
	SUPPLIER_DETAILS_READONLY_UI_OBJECT_PROPERTIES = 1157,

	//1200 - 1249 product codes
	PRODUCT_CODE_LIST = 1200,
	PRODUCT_CODE_ADD = 1201,
	PRODUCT_CODE_EDIT = 1202,
	ALLOWED_PRODUCT_CODE = 1203,

	//1250 - 1299 distributor
	DISTRIBUTOR_LIST = 1250,
	DISTRIBUTOR_ADD = 1251,
	DISTRIBUTOR_EDIT = 1252,
	DISTRIBUTOR_DENIED_IN_IMRSC_MANAGE_OPERATORS = 1253,
	DISTRIBUTOR_DETAILS_HIDDEN_UI_OBJECT_PROPERTIES = 1254,
	DISTRIBUTOR_DEL = 1255,
	DISTRIBUTOR_DETAILS_READONLY_UI_OBJECT_PROPERTIES = 1256,
	DISTRIBUTOR_HIDE_METER_IMPULSE_WEIGHT = 1257,
	DISTRIBUTOR_MODULE_HIDDEN_UI_OBJECT_PROPERTIES = 1258,
	DISTRIBUTOR_IMPORT_OP = 1259,

	//1300 - 1349 article (towar, zaciagany z CDN)
	ARTICLE_LIST = 1300,
	ARTICLE_ADD = 1301,
	ARTICLE_EDIT = 1302,
	ARTICLE_DEL = 1303,

	//1350 - 1399 package
	PACKAGE_LIST = 1350,
	PACKAGE_ADD = 1351,
	PACKAGE_EDIT = 1352,
	PACKAGE_DEL = 1353,
	PACKAGE_ORDER = 1354,
	PACKAGE_ORDER_APPROVE = 1355,
	PACKAGE_ORDER_COMPLEMENT = 1356,
	PACKAGE_NEW_ORDER = 1357,
	PACKAGE_ERRORS_REPORT_OP = 1358,
	PACKAGE_MAGAZINE_REPORT_OP = 1359,
	PACKAGE_DEFICIENCIES_REPORT_OP = 1360,
	PACKAGE_FITTER_PACKAGE_APPROVE = 1361, //Akceptacja paczki w imieniu serwisanta
	PACKAGE_DETAILS_HIDDEN_UI_PROPERTIES = 1364,
	PACKAGE_DETAILS_READONLY_UI_OBJECT_PROPERTIES = 1365,

	//1400 - 1499 Delivery, Reconciliation
	DELIVERY_ADVISOR_LIST = 1400,
	DELIVERY_ORDER_LIST = 1401,
	DETAIL_VIEW_LIST = 1402,
	DELIVERY_BATCH_ADD = 1403,
	DELIVERY_BATCH_EDIT = 1404,
	DELIVERY_BATCH_DEL = 1405,
	DELIVERY_BATCH_COMMIT_OP = 1406,
	ALLOWED_DETAIL_VIEW = 1407,
	LOCATION_DISTANCE_CALC_OP = 1408,
	DELIVERY_TRUCK_LIST = 1409,
	DELIVERY_TRUCK_ADD = 1410,
	DELIVERY_TRUCK_EDIT = 1411,
	DELIVERY_TRUCK_DEL = 1412,
	FUEL_TERMINAL_LIST = 1413,
	FUEL_TERMINAL_ADD = 1414,
	FUEL_TERMINAL_EDIT = 1415,
	FUEL_TERMINAL_DEL = 1416,
	TRUCK_DRIVER_LIST = 1417,
	TRUCK_DRIVER_ADD = 1418,
	TRUCK_DRIVER_EDIT = 1419,
	TRUCK_DRIVER_DEL = 1420,
	DELIVERY_INETLLIGENCE_SIMULATE_OP = 1421,
	DELIVERY_INETLLIGENCE_PLAN_OP = 1422,
	DELIVERY_INTELLIGENCE_ROUTE_OP = 1423,
	DELIVERY_INTELLIGENCE_CUSTOM_PREDICTION = 1424,
	LOCATION_HISTORY_VIEW = 1425,
	DELIVERY_INTELLIGENCE_ROUTE_VERIFICATION_OP = 1426,
	DELIVERY_HISTORY_SIMULATE_OP = 1427,
	DELIVERY_RECONCILIATION_LIST = 1428,
	DELIVERY_ALLOWED_DATA_SOURCE_TYPE_VIEW = 1429,
	DELIVERY_RECALCULATION_REFUEL_OP = 1430,
	DELIVERY_RECALCULATION_TANKS_OP = 1431,
	ALARMS_CONFIRMATION_ENABLED = 1432,
	IRC_SIR2_LIST = 1433,
	ANOMALY_DETECTION_LIST = 1434,
	AUTOCALIBRATION_MODULE_LIST = 1435,
	RECONCILIATION_STATUS_CHANGING_ENABLED = 1436,
	STATION_ANALYSIS_PRIORITIZATION_LIST = 1437,
	STATION_ANALYSIS_PRIORITIZATION_ADVANCED_SETTINGS = 1438,

	//1500 - 1549 Template/Pattern
	TEMPLATE_LIST = 1500,
	TEMPLATE_EDIT = 1501,
	TEMPLATE_ADD = 1502,
	TEMPLATE_LIST_ALL = 1503,
	PATTERN_LIST = 1504,
	PATTERN_EDIT = 1505,
	PATTERN_ADD = 1506,
	TEMPLATE_PATTERN_COPY = 1507,

	//1550 - 1559 Equipment pool
	EQUIPMENT_POOL_LIST = 1550,
	EQUIPMENT_POOL_EDIT = 1551,

	//1575 - 1599 System and Module Data
	MODULE_DATA_LIST = 1575,
	MODULE_DATA_EDIT = 1576,
	MODULE_DATA_ADD = 1577,
	MODULE_DATA_DEL = 1578,
	SYSTEM_DATA_LIST = 1579,
	SYSTEM_DATA_EDIT = 1580,
	SYSTEM_DATA_ADD = 1581,
	SYSTEM_DATA_DEL = 1582,
	MODULE_LIST = 1583,
	MODULE_ADD = 1584,
	MODULE_EDIT = 1585,
	COMMAND_CODE_TYPE_LIST = 1586,
	COMMAND_CODE_TYPE_ADD = 1587,
	COMMAND_CODE_TYPE_EDIT = 1588,
	COMMAND_CODE_TYPE_DEL = 1589,
	DB_AUDIT_LIST = 1590,
	ALLOWED_MODULE = 1591,

	//1600 - 1649 Schedule
	SCHEDULE_LIST = 1600,
	SCHEDULE_ADD = 1601,
	SCHEDULE_EDIT = 1602,
	SCHEDULE_DEL = 1603,
	SCHEDULE_ACTION_LIST = 1604,
	SCHEDULE_ACTION_ADD = 1605,
	SCHEDULE_ACTION_EDIT = 1606,
	SCHEDULE_ACTION_DEL = 1607,

	//1650 - 1699
	PROFILE_LIST = 1650,
	PROFILE_ADD = 1651,
	PROFILE_EDIT = 1652,
	PROFILE_DEL = 1653,
	PROFILE_IMPORT_OP = 1654,
	PROFILE_EXPORT_OP = 1655,
	PROFILE_ACTION_LIST = 1656,
	PROFILE_ACTION_RUN = 1657,

	//1700 - 1749 (SITA)
	SITA_READOUT = 1700,
	SITA_INSTALLATION = 1701,
	SITA_SERVICE = 1702,
	SITA_IMR_SCAN = 1703,
	SITA_SETTINGS = 1704,
	SITA_SERVICE_RESYNCHRONISATION = 1705,
	SITA_SERVICE_REPROGRAMMING = 1706,
	SITA_SERVICE_DOWNLOAD_ARCHIVES = 1707,
	SITA_SERVICE_DOWNLOAD_LOG = 1708,
	SITA_READOUT_METHOD_CONFIG = 1709,
	SITA_FRAMES_PREVIEW = 1710,
	SITA_SERVICE_MULTIHOP = 1711,
	SITA_SERVICE_SEND_CONFIGURATION = 1712,
	SITA_IMR_CLUSTER_SCAN = 1713,
	SITA_IMR_CLUSTER_SCAN_VERIFICATION = 1714,
	SITA_IMR_CLUSTER_SCAN_VERIFICATION_ADVANCED = 1715,
	SITA_SETTINGS_ARANGE = 1716,
	SITA_SETTINGS_RADIO = 1717,
	SITA_SETTINGS_ADV_RADIO = 1718,
	SITA_SERVICE_GMC = 1719,
	SITA_SERVICE_CHANGE_BATTERY_GASMETER = 1720,
	SITA_INSTALLATION_SETTINGS = 1721,
	SITA_CLIENT_SIGNATURE_REQUIRED = 1722,
	SITA_FITTER_SIGNATURE_REQUIRED = 1723,
	SITA_ANALOG_ALARM_EDIT_ENABLE = 1724,
	SITA_SERVICE_READ_DIAGNOSTICS = 1725,
	SITA_SERVICE_SET_GAS_ENERGY = 1726,
	SITA_SERVICE_REPROGRAMMING_BY_OPTOBT = 1727,
	SITA_SERVICE_SIM_CARD_TEST = 1728,
	SITA_SERVICE_VALVE_TEST = 1729,
	SITA_READOUT_BROADCAST_ENABLED = 1730,
	SITA_ROUTE_ALL_LOCATION_ENABLED = 1731,
	SITA_TANK_LOCALIZATION_AVAILABLE = 1732,
	SITA_SERVICE_REPLACE_OKO = 1733,
	SITA_SERVICE_CHECK_DEVICE_STATE = 1734,
	SITA_REPORT_ERROR_ENABLED = 1735,
	SITA_SERVICE_PRESSURE_PREVIEW = 1736,
	SITA_SERVICE_GSM_TEST = 1737,
	SITA_CREATE_NEW_LOCATION = 1738,
	SITA_UNALLOCATED_TASK_VIEW = 1739,
	SITA_LPG_INSTALL_TELEMETRY_DEVICES = 1740,
	SITA_LPG_INSTALL_OTHER_DEVICES = 1741,
	SITA_ADDITIONAL_ACTION_DURING_SYNCHRONIZATION = 1742,
	SITA_INSTALLATION_PROTOCOL_ENABLED = 1743,
	SITA_SERVICE_PROBE_REMOVE = 1744,
	SITA_SERVICE_PROBE_REPLACE = 1745,
	SITA_ASSIGN_TASK_IN_BRANCH_ENABLED = 1746,
	SITA_ASSIGN_ADAPTER_DURING_INSTALLATION_ENABLED = 1747,
	SITA_ASSIGN_ADAPTER_DURING_INSTALLATION_REQUIRED = 1748,
	SITA_SERVICE_FREQUENCY_CHANGE = 1749,

	//1750 - 1799
	SMS_ACTIONS_LIST = 1750,
	SMS_ACTIONS_VIEW = 1751,
	SMS_ACTION_EDIT = 1752,
	SMS_ACTION_ADD = 1753,

	//1800 - 1849 service
	SERVICE_LIST = 1800,
	SERVICE_ADD = 1801,
	SERVICE_EDIT = 1802,
	SERVICE_DEL = 1803,

	//1850 - 1899 contract
	CONTRACT_LIST = 1850,
	CONTRACT_ADD = 1851,
	CONTRACT_EDIT = 1852,
	CONTRACT_DEL = 1853,

	//1900-1949 service package
	SERVICE_PACKAGE_LIST = 1900,
	SERVICE_PACKAGE_ADD = 1901,
	SERVICE_PACKAGE_EDIT = 1902,
	SERVICE_PACKAGE_DEL = 1903,

	//1950-1999 diagnostic action
	DIAGNOSTIC_ACTION_LIST = 1950,
	DIAGNOSTIC_ACTION_ADD = 1951,
	DIAGNOSTIC_ACTION_EDIT = 1952,
	DIAGNOSTIC_ACTION_DEL = 1953,

	//2050-2099 service list
	SERVICE_LIST_LIST = 2050,
	SERVICE_LIST_ADD = 2051,
	SERVICE_LIST_EDIT = 2052,
	SERVICE_LIST_DEL = 2053,
	VIEW_THE_CURRENT_STATE_OF_THE_VALVE = 2054,
	CONTROL_VALVE = 2055,
	HISTORY_VALVE_CONTROL = 2056,
	MANAGE_VALVE_ACTIONS_STATE = 2057,
	SERVICE_LIST_DEVICE_TEST = 2058,
	SERVICE_LIST_DEVICE_CUSTOMER_DAMAGE_MARK_OP = 2059,
	SERVICE_LIST_DEVICE_REFURBISMENNT_MARK_OP = 2060,

	//2100-2149 shipping list
	SHIPPING_LIST_LIST = 2100,
	SHIPPING_LIST_ADD = 2101,
	SHIPPING_LIST_EDIT = 2102,
	SHIPPING_LIST_DEL = 2103,
	SHIPPING_LIST_GENERATE_REPORT_OP = 2104,
	SHIPPING_LIST_GENERATE_PROTOCOL_OP = 2105,

	//2150-2199 location hierarchy
	LOCATION_HIERARCHY_LIST = 2150,
	LOCATION_HIERARCHY_ADD = 2151,
	LOCATION_HIERARCHY_EDIT = 2152,
	LOCATION_HIERARCHY_DEL = 2153,

	//2200-2249
	DEVICE_ORDER_NUMBER_LIST = 2200,
	DEVICE_ORDER_NUMBER_ADD = 2201,
	DEVICE_ORDER_NUMBER_EDIT = 2202,
	DEVICE_ORDER_NUMBER_DEL = 2203,

	//2250-2299
	CASHIER_NEW_PAYMENT = 2250,
	CASHIER_TOPUP_HISTORY = 2251,
	CASHIER_ENERGY_SUPPLIER_AND_TARIF = 2252,
	CASHIER_CONSUMER_ACCOUNT = 2253,
	CASHIER_CONSUMER_DETAILS = 2254,
	CASHIER_CONSUMER_COMMENT = 2255,
	CASHIER_METER_READINGS = 2256,
	CASHIER_CHARGES = 2257,
	CASHIER_CREDIT = 2258,
	CASHIER_NEW_PAYMENT_HBC_RAR = 2259,
	CASHIER_OLD_PANEL = 2260,
	CASHIER_GENERATE_TOPUP_DEFAULT_CONFIRMATION = 2261,
	CASHIER_GENERATE_TOPUP_AMANORA_CONFIRMATION = 2262,
	CASHIER_PRINT_TOPUP_CONFIRMATION = 2263,
	CASHIER_PRINT_MONTHLY_SETTLEMENT = 2264,
	CASHIER_PANEL_VIEW = 2266,

	//2300 - 2349

	DEPOSITORY_ELEMENT_LIST = 2300,
	DEPOSITORY_ELEMENT_ADD = 2301,
	DEPOSITORY_ELEMENT_EDIT = 2302,
	DEPOSITORY_ELEMENT_DEL = 2303,

	//2350-2399 - dalszy ciąg Activity dla operatora (wpisy znajdują się pod starszymi wpisami dla Operatora)

	OPERATOR_ALLOW_UPDATE_OWED = 2386,

	//2400-2449

	PERFORMANCES_LIST = 2400,
	PERFORMANCES_ADD = 2401,
	PERFORMANCES_EDIT = 2402,
	PERFORMANCES_DEL = 2403,
	PERFORMANCES_LPG_KPI_LIST = 2404,

	//2450-2499

	IMR_SERVER_LIST = 2450,
	IMR_SERVER_ADD = 2451,
	IMR_SERVER_EDIT = 2452,
	IMR_SERVER_DEL = 2453,

	//2500-2549
	FILE_LIST = 2500,
	FILE_ADD = 2501,
	FILE_EDIT = 2502,
	FILE_DEL = 2503,
	FILE_UNBLOCK = 2504,
	//2550-2599

	FAULT_CODE_LIST = 2550,
	FAULT_CODE_ADD = 2551,
	FAULT_CODE_EDIT = 2552,
	FAULT_CODE_DEL = 2553,
	FAULT_CODE_ASSIGN_OP = 2554,
	FAULT_CODE_DASHBOARD_VIEW = 2555,
	FAULT_CODE_MINOR_VIEW = 2556,
	FAULT_CODE_DASHBOARD_SUMMARY_VIEW = 2557,
	FAULT_CODE_DASHBOARD_BIG_FAULT_VIEW = 2558,

	//2600-2699 fuelprime
	FP_REPORT_ESCALATE_ALLOWED = 2600,
	FP_REPORT_REPORT_ALLOWED = 2601,
	FP_REPORT_CONFIRM_ALLOWED = 2602,
	FP_LDAP_ADMIN_ALLOWED = 2603,
	FP_LDAP_SHELL_EMPLOYEE_ALLOWED = 2604,
	FP_LDAP_ALERT_ALLOWED = 2605,
	FP_LDAP_BALANCE_ALLOWED = 2606,
	FP_LDAP_CONFIGURATION_ALLOWED = 2607,
	FP_LDAP_DATASTOCK_ALLOWED = 2608,
	FP_LDAP_DELIVERY_ALLOWED = 2609,
	FP_LDAP_EVENT_ALLOWED = 2610,
	FP_LDAP_FUELPRIME_ALLOWED = 2611,
	FP_LDAP_MAPS_ALLOWED = 2612,
	FP_LDAP_PLIP_ALLOWED = 2613,
	FP_LDAP_READ_ONLY_ALLOWED = 2614,
	FP_LDAP_RECONCILIATION_ALLOWED = 2615,

	//2700-2799 Configuration
	CONFIGURATION_CONTROL_HIDDEN_UI_OBJECT_PROPERTIES = 2700,

	//2800-2819 SIMAX
	SIMAX_DASHBOARD_VIEW = 2800,

	//2820-2899 WEBSIMAX
	WEBSIMAX_DASHBOARD_VIEW = 2820,
	WEBSIMAX_ALARM_SUMMARY_VIEW = 2821,
	WEBSIMAX_MAIN_MENU_VIEW = 2822,
	WEBSIMAX_MODULE_VIEW_COLUMN_DEFINITION_OP = 2823,
	WEBSIMAX_CUSTOM_SCRIPT_RUN_OP = 2824,
	WEBSIMAX_PAIR_METER_WITH_DEVICE = 2825,
	WEBSIMAX_DASHBOARD_CONFIGURATION = 2826,
	WEBSIMAX_DASHBOARD_ITEM_CONFIGURATION = 2827,
	WEBSIMAX_DASHBOARD_DISTRIBUTOR_SAVE = 2828,
	WEBSIMAX_DASHBOARD_PROFILE_SAVE = 2829,
	DEPOSITORY_LIST = 2830,
	DEPOSITORY_EDIT = 2831,
	DEPOSITORY_ADD = 2832,
	DEPOSITORY_DEL = 2833,
	DEPOSITORY_DETAILS_HIDDEN_UI_OBJECT_PROPERTIES = 2834,
	DEPOSITORY_DETAILS_READONLY_UI_OBJECT_PROPERTIES = 2835,
	WEBSIMAX_DASHBOARD_CONFIGURE_ANY_REFRESH_PERIOD = 2836,
	WEBSIMAX_DASHBOARD_DEL = 2837,
	WEBSIMAX_COLUMN_REORDER_DISALLOWED = 2838,
	DEPOSITORY_EDIT_ALWAYS_INCLUDE_DEPOSITORY_ELEMENT_OP = 2839,
	DEPOSITORY_MODULE_HIDDEN_UI_OBJECT_PROPERTIES = 2840,
	WEBSIMAX_CHART_OPTION_HIDDEN = 2841,
	WEBSIMAX_MEASUREMENT_DATA_TYPE_OPTION_HIDDEN = 2842,
	GROUPING_LOCATION_LIST = 2843,
	GROUPING_LOCATION_ADD = 2844,
	GROUPING_LOCATION_EDIT = 2845,
	GROUPING_LOCATION_DEL = 2846,
	GROUPING_LOCATION_MODULE_HIDDEN_UI_OBJECT_PROPERTIES = 2847,
	GROUPING_LOCATION_DETAILS_HIDDEN_UI_PROPERTIES = 2848,
	ALLOWED_GROUPING_LOCATION_TYPE = 2849,
	GROUPING_LOCATION_TYPE_MODULE_HIDDEN_UI_OBJECT_PROPERTIES = 2850,
	GROUPING_LOCATION_TYPE_DETAILS_HIDDEN_UI_PROPERTIES = 2851,
	GROUPING_LOCATION_TYPE_DETAILS_READONLY_UI_OBJECT_PROPERTIES = 2852,
	GROUPING_LOCATION_DETAILS_READONLY_UI_OBJECT_PROPERTIES = 2853,
	WEBSIMAX_DASHBOARD_ADD = 2854,
	TASK_TYPE_LIST = 2855,
	TASK_TYPE_EDIT = 2856,
	TASK_TYPE_ADD = 2857,
	TASK_TYPE_DEL = 2858,
	TASK_TYPE_MODULE_HIDDEN_UI_OBJECT_PROPERTIES = 2859,
	TASK_TYPE_DETAILS_HIDDEN_UI_PROPERTIES = 2860,
	TASK_TYPE_DETAILS_READONLY_UI_OBJECT_PROPERTIES = 2861,

	//2900 - 2999 (SITA) - dalszy ciąg Activity dla SITA (wpisy znajdują się pod starszymi wpisami dla SITA)
	SITA_INSTALLATION_COMPASS_VISIBLE = 2900,
	SITA_SHOW_DEVICES_IN_RANGE = 2901,
	SITA_INSTALLATION_BY_WIZARD_ALLOWED = 2902,
	SITA_INSTALLATION_CUSTOM_IMPULSE_WEIGHT = 2903,
	SITA_READOUT_STOPGO_ENABLED = 2904,
	SITA_SCAN_KNOWN_NODES = 2905,
	SITA_LPG_INSTALL_ARANGE = 2906,
	SITA_LPG_ADD_NEW_TANK = 2907,
	SITA_SHOW_EMPTY_AREA = 2908,
	SITA_DIEHL_SCAN = 2909,
	SITA_ARRANGED_FITTER_FISIT_DATE_ENABLE = 2910,
	SITA_ATTACHMENT_GALLERY_ENABLE = 2911,
	SITA_FINISH_TASK_AFTER_ACTION = 2912,
	SITA_CREATE_LOCAL_TASK = 2913,
	SITA_SHOW_CORE_DEVICE_INSTEAD_DEPOSITORY_ELEMENT_DEVICE = 2914,
	SITA_READOUT_DAILY_ARCHIVE_ENABLED = 2915,
	SITA_SERVICE_ACTION_ON_TOP = 2916,
	SITA_SERVICE_PIN_MENU = 2917,
	SITA_SERVICE_PIN_VALVE = 2918,
	SITA_INSTALLATION_OKOI505_LC_DISABLED = 2919,
	SITA_SERVICE_RADIO_QUALITY_TEST = 2920,
	SITA_SERVICE_RADIO_QUALITY_TEST_AFTER_INSTALLATION = 2921,
	SITA_TASK_AND_ROUTE_TAB_VIEW_ALLOWED = 2922,
	SITA_INSTALLATION_PHOTO_REQUIRED = 2923,
	SITA_REJECT_TASK_ENABLED = 2924,
	SITA_INSTALLATION_DEVICE_LOCATION_PLACE = 2925,
	SITA_SKIP_INSTALLATION_FORM = 2926,
	SITA_INSTALLATION_GSM_TEST_RECOMMENDED = 2927,
	SITA_HIDE_OBJECT = 2928,
	SITA_COMMISSION_ENABLED = 2929,
	SITA_TOPUP_ENABLED = 2930,
	SITA_SERVICE_ACO_TIME_SYNCHRONIZATION_ENABLED = 2931,
	SITA_SERVICE_ACO_READ_BANK_ENABLED = 2932,
	SITA_EVC_GSM_LEVEL = 2933,
	SITA_REQUIRE_VALVE_TEST_AFTER_INSTALLATION = 2934,
	SITA_SENSITIVE_DATA_RESTRICTED_STORAGE = 2935,
	SITA_INSTALLATION_WAY_OKO_5xx5_xxC1 = 2936,
	SITA_LCD_8_DIGITS_REQUIREMENT = 2937,
	SITA_SERVICE_GPRS_AVAILABILITY = 2938,
	SITA_SERVICE_CHANGE_DEVICE_TRANSMISSION_LINK = 2939,
	SITA_READOUT_SHOW_NOT_EQUIPPED_LOCATION = 2940,
	SITA_REQUIRE_OLD_DEVICE_VALUES = 2941,
	SITA_CONFIGURE_HEAT_ALARMS = 2942,
	SITA_SKIP_ABRAND_FORM = 2943,
	SITA_SERVICE_DEVICE_EVENT_PHONE = 2944,
	SITA_SERVICE_APN_CONFIGURATION = 2945,

	//3000-3049
	MOBILE_NETWORK_CODE_LIST = 3000,
	MOBILE_NETWORK_CODE_ADD = 3001,
	MOBILE_NETWORK_CODE_EDIT = 3002,
	MOBILE_NETWORK_CODE_DEL = 3003,

	//3050-3099 VERSION
	VERSION_LIST = 3050,
	VERSION_ADD = 3051,
	VERSION_EDIT = 3052,
	VERSION_DEL = 3053,
	VERSION_CAN_REVERT_VERSION_STATE = 3054,
	ALLOWED_VERSION_STATE_VIEW = 3055,
	ALLOWED_VERSION_STATE_EDIT = 3056,
	ALLOWED_VERSION_STATE_CHANGE = 3057,
	ALLOWED_VERSION_REFERENCE_TYPE = 3058,

	//3100 - 3159 SESSION
	SESSION_LIST = 3100,
	SESSION_DATA_LIST = 3101,
	SESSION_EVENT_LIST = 3102,
	SESSION_EVENT_DATA_LIST = 3103,

	//3160 - 3199 ALARM_EVENT
	ALARM_EVENT_LIST = 3160,
	ALARM_EVENT_ADD = 3161,
	ALARM_EVENT_EDIT = 3162,
	ALARM_EVENT_DEL = 3163,
	ALARM_EVENT_MODULE_HIDDEN_UI_OBJECT_PROPERTIES = 3164,

	//3200 - 3259 ALARM_GROUP
	ALARM_GROUP_LIST = 3200,
	ALARM_GROUP_ADD = 3201,
	ALARM_GROUP_EDIT = 3202,
	ALARM_GROUP_DEL = 3203,
	ALARM_GROUP_DETAILS_READONLY_UI_OBJECT_PROPERTIES = 3204,
	ALARM_GROUP_DETAILS_HIDDEN_UI_OBJECT_PROPERTIES = 3205,

	//3260 - 3299
	WORK_LIST = 3260,
	WORK_RUN = 3261,
	WORK_STOP = 3262,
	WORK_STOP_WITH_ERROR = 3263,

	//3300 - 3399
	IMREVA_SEND_LOG_FILE_OP = 3300,
	IMREVA_SUMMARY_TANK_VIEW = 3301,

	//3400 - 3449
	CONFIGURATION_PROFILE_LIST = 3400,
	CONFIGURATION_PROFILE_ADD = 3401,
	CONFIGURATION_PROFILE_EDIT = 3402,
	CONFIGURATION_PROFILE_DEL = 3403,
	CONFIGURATION_PROFILE_DETAILS_HIDDEN_UI_PROPERTIES = 3404,
	CONFIGURATION_PROFILE_DETAILS_READONLY_UI_OBJECT_PROPERTIES = 3404,


	//3450 - 3499
	ALARM_DEF_EDIT_HIDDEN_UI_PROPERTIES = 3450,
	ALARM_DEF_MULTIPLE_ADD = 3451,

	//3660 - 3679 SCHEMA
	SCHEMA_LIST = 3660,
	SCHEMA_ADD = 3661,
	SCHEMA_EDIT = 3662,
	SCHEMA_DEL = 3663,

	//3680 - 3699 OPERATOR_GROUP
	OPERATOR_GROUP_LIST = 3680,
	OPERATOR_GROUP_ADD = 3681,
	OPERATOR_GROUP_EDIT = 3682,
	OPERATOR_GROUP_DEL = 3683,
	OPERATOR_GROUP_DETAILS_READONLY_UI_OBJECT_PROPERTIES = 3684,
	OPERATOR_GROUP_MODULE_HIDDEN_UI_OBJECT_PROPERTIES = 3685,
	OPERATOR_GROUP_DETAILS_HIDDEN_UI_PROPERTIES = 3686,

	OPERATOR_CAN_RESET_PASSWORD = 3710,

	//orders
	ORDER_LIST = 3750,
	ORDER_ADD = 3751,
	ORDER_EDIT = 3752,
	ORDER_DEL = 3753,
	ORDER_MODULE_HIDDEN_UI_OBJECT_PROPERTIES = 3754,
	ORDER_DETAILS_HIDDEN_UI_PROPERTIES = 3755,
	ORDER_DETAILS_READONLY_UI_OBJECT_PROPERTIES = 3756,

	//3850 - 3899 TECHNICAL_PERMISSION
	TECHNICAL_PERMISSION_LIST = 3850,
	TECHNICAL_PERMISSION_ADD = 3851,
	TECHNICAL_PERMISSION_EDIT = 3852,
	TECHNICAL_PERMISSION_DEL = 3853,

	GEN_ACTION_VALVE_ABORT_RUNNING = 2021, // Permission to abort running 'Operation valve' action
	GEN_ACTION_VALVE_HISTORY = 2014, // Permission to view history of 'Operation valve' action
	GEN_ACTION_VALVE_PERFORM = 2013, // Permission to perform 'Operation valve' action
	GEN_ACTION_VALVE_REMOVE_SCHEDULED = 2020, // Permission to remove scheduled 'Operation valve' action
	GEN_ACTION_VALVE_VIEW = 2012, // Permission to view 'Operation valve' action
	GEN_CHANGE_CID = 2028, // Permission to execute 'Change CID' action on Device
	GEN_SYNCH_COUNTER = 2031, // Permission to synchronize impulse counter

	GEN_CONSUMER_TANKS_VIEW = 2022, // Permission to view tanks at location
	GEN_LOCATIONS_VIEW = 2001, // Permission to view main map with locations
	GEN_GMAP_VIEW = 2030, // Permission to view Google map with locations

	GEN_STATION_MEASURES_VIEW = 2008, // Permission to view station measures
	GEN_STATIONS_REPORT_VIEW = 2003, // Permission to view stations report
	GEN_METERS_MANAGE = 2029, // Permission to manage meters

	LOC_VIEW_ON_MAP = 3001, // Permission to view location on map

	// ->ALARM_LIST
	GEN_ALARMS_VIEW = 2023, // Permission to view alarms
	// ->ALARM_MANAGE
	GEN_ALARMS_MANAGE = 2032, //Permission to manage alarms

	GEN_USER_CONFIRM = 2033,
	GEN_DEMOKIT_ORDER = 2034,
	GEN_MANAGE_ACCOUNT = 2035,
	GEN_CHANGE_PASSWORD = 2036,
	GEN_MANAGE_CONTENT = 2037,
	GEN_PREVIEW_ORDERS = 2038,
	GEN_MY_DEVICES = 2039,
	GEN_MY_ORDERS = 2040,
	GEN_LIVE_DEMO = 2041,
	GEN_VISUALIZATION = 2042,
	GEN_REPORT_ISSUE = 2043,
	GEN_ISSUE_STATUS = 2044,
	// ->MEASUREMENTS_LIST
	GEN_ARCHIVE_DATA_CHART_VIEW = 2027, // Permission to view archive data chart
	// ->MEASUREMENTS_LIST
	GEN_ARCHIVE_DATA_REPORT_VIEW = 2002, // Permission to view archive data report
	// ->MEASUREMENTS_LIST
	GEN_LATEST_DATA_REPORT_VIEW = 2011, // Permission to view latest data report

	// ->LOCATION_ADD
	GEN_LOCATIONS_CREATE = 2016, // Permission to create locations
	// ???????????????
	GEN_LOCATIONS_MANAGE = 2015, // Permission to manage locations
	// ->LOCATION_EDIT
	GEN_LOCATIONS_MODIFY = 2017, // Permission to modify locations
	// ->LOCATION_DEL
	GEN_LOCATIONS_REMOVE = 2018, // Permission to remove locations
	// -> REPORTS_LIST
	GEN_REPORTS_MANAGE = 2019,

	// ->MEASUREMENTS_MANUAL_ADD_OP
	GEN_MEASURES_SEND = 2009, // Permission to enter and send measures

	// -> InteliGAS data types
	GEN_LOCATIONS_MODIFY_ATTRIBUTES = 2045,
	GEN_LOCATIONS_MODIFY_ADDITIONAL_ATTRIBUTES = 2046,
	GEN_CARDS_MANAGEMENT = 2047,
	GEN_CONFIGURATION_VIEW = 2048,
	GEN_SYMBOLS_SIZE_CONFIGURE = 2049,
	GEN_LOCATION_ATTRIBUTES_MANAGEMENT = 3003,
	GEN_LOCATION_ATTRIBUTE_CODE_MANAGEMENT = 3004,
	GEN_MAP_VIEW = 3005,
	GEN_IMR_INSTALLATIONS_VIEW = 3006,
	GEN_SETS_VIEW = 3007,
	GEN_EMPTY_LOCATIONS_VIEW = 3008,
	GEN_TREE_VIEW = 3009,
	GEN_COMMUNICATION = 3010,
	GEN_MEASURE_SYMBOLS_VIEW = 3011,
	GEN_MEASURES_REPORT = 3012,
	GEN_VIEW_LAST_MEASURE = 3013,
	GEN_CHANNEL_REPORT_VIEW = 3014,
	GEN_INTELIGAS_LOCATIONS_VIEW = 3015,
	LOC_SEND_MEASURES = 3002, // Permission to enter and send location measures

	GEN_PASSWORD_CHANGE = 2010, // Permission to change operator password
	GEN_MANUAL_DOWNLOAD = 2006, // Permission to download application manual
	GEN_MAINTENANCE_CONTACT_VIEW = 2005, // Permission to view maintenance contact
	GEN_APPLICATION_INFO_VIEW = 2004, // Permission to view application info
	GEN_REFUELS_IMPORT = 2026, // Permission to import files with refuels
	GEN_REFUELS_MANAGE = 2025, // Permission to manage refuels
	GEN_REFUELS_VIEW = 2024, // Permission to view refuels

	GEN_VERSION_INFO_VIEW = 2007, // Permission to view application version info
}
